var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43.5,
    fill: "#FCFCFC",
    stroke: "#747474"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_10072",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 44,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22.5,
    width: 43,
    height: 43,
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_10072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.786 34.0517C38.2282 32.3225 40.0472 31.2505 42.2607 30.8258L42.6665 30.748V30.3348V29.3333C42.6665 28.9547 42.793 28.6494 43.0539 28.3881L43.054 28.388C43.3149 28.1264 43.6191 28 43.9957 28C44.3724 28 44.6787 28.1265 44.9429 28.3893L44.9431 28.3895C45.2062 28.6511 45.3332 28.9559 45.3332 29.3333V30.3348V30.748L45.739 30.8258C47.9524 31.2505 49.7715 32.3225 51.2136 34.0517C52.6536 35.7787 53.3714 37.7717 53.3714 40.0515V54.577V55.077H53.8714H56.3332V55.9103H31.6665V55.077H34.1283H34.6283V54.577V40.0515C34.6283 37.7717 35.3461 35.7788 36.786 34.0517ZM36.786 34.0517L36.402 33.7315L36.786 34.0517ZM42.2584 59.9824L42.2583 59.9823C41.8973 59.6196 41.6745 59.2105 41.5843 58.7436H46.4157C46.3253 59.2143 46.1007 59.624 45.7372 59.9846L45.7371 59.9847C45.2493 60.469 44.6771 60.7049 43.9934 60.7049C43.3107 60.7049 42.7417 60.4682 42.2584 59.9824ZM35.4616 54.577V55.077H35.9616H52.0381H52.5381V54.577V40.0515C52.5381 37.6914 51.7034 35.6671 50.0436 34.0072C48.3838 32.3474 46.3596 31.5128 43.9998 31.5128C41.6401 31.5128 39.6159 32.3474 37.9561 34.0072C36.2962 35.6671 35.4616 37.6914 35.4616 40.0515V54.577Z",
    fill: "#232323",
    stroke: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.b59bd4f394775db8522cf9b86d1b5b60.svg";
export { ForwardRef as ReactComponent };